import React, { useState, useMemo, useEffect, useContext } from "react";
import { useNavigate ,useLocation} from "react-router-dom";
import DataTable from "./../../../../Layout/Table/TableLayoutOpp";
import { Button, Row, Col, Form, Modal } from "react-bootstrap";
import Navbar from "../../../../Shared/ManagerNavbar/Navbar";
import { FaEdit, FaTrash, FaEye, FaUserPlus, FaComment, FaDownload, FaSyncAlt, FaCopy, FaCalendarAlt, FaTimes } from "react-icons/fa";
import { HiUserGroup } from "react-icons/hi";
import "./ViewLeads.css";
import axios from "axios";
import { AuthContext } from "../../../../AuthContext/AuthContext";
import { baseURL } from "../../../../Apiservices/Api";
import { webhookUrl } from "../../../../Apiservices/Api";
import { FontSizeContext } from "../../../../Shared/Font/FontContext";
import * as XLSX from 'xlsx';
import { FaSave } from 'react-icons/fa';
import { useQuery } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import Loader from "../../../../Loader/Loader";
import { adminMail } from '../../../../Apiservices/Api';
import CommentsModalPopmangaer from '../../../Admin/Leads/ViewLeads/CommentsModalPop/CommentsModalPopmangaer';
const ViewLeads = () => {
  const [message, setMessage] = useState('');
  const { authToken, userId, managerId, userName } = useContext(AuthContext);
  // const [data, setData] = useState([]);
    const queryClient = useQueryClient();
const {
  data = [],
  isLoading,
  isError,
  error,
} = useQuery({
  queryKey: ['manager-add-leads', userId], // 🔥 important
  refetchInterval: 3000, // Refetch every 3 seconds to keep data updated
  queryFn: async () => {
    if (!userId) return [];

    const response = await fetch(`${baseURL}/api/addleads/statuslead`);
    const json = await response.json();

    const list = Array.isArray(json.data) ? json.data : [];

    // Apply your filter logic
    const filtered = list.filter(
      (enquiry) =>
        enquiry.managerAssign !== userId &&
        enquiry.managerid == userId
    );

    return filtered;
  },
  enabled: !!userId, // only run when userId exists
  keepPreviousData: true,
});

  
// Add this state with your other state declarations
const [loading, setLoading] = useState(false);

    const location = useLocation();
  const [pageIndex, setPageIndex] = useState(0);
const [showCommentModal, setShowCommentModal] = useState(false);
const [selectedLeadForComment, setSelectedLeadForComment] = useState(null);
  const [searchTerm, setSearchTerm] = useState(localStorage.getItem("searchTerm-1") || "");
  const [filterStatus, setFilterStatus] = useState(localStorage.getItem("filterStatus-1") || "");
  const [filterDestination, setFilterDestination] = useState(localStorage.getItem("filterDestination-1") || "");
  const [filterOppStatus1, setFilterOppStatus1] = useState(localStorage.getItem("filterOppStatus1-1") || "Open");
  const [filterOppStatus2, setFilterOppStatus2] = useState(localStorage.getItem("filterOppStatus2-1") || "");

  const [filterAssignee, setFilterAssignee] = useState(localStorage.getItem("filterAssignee-1") || "");
  const [filterStartDate, setFilterStartDate] = useState(localStorage.getItem("filterStartDate-1") || "");
  const [filterEndDate, setFilterEndDate] = useState(localStorage.getItem("filterEndDate-1") || "");
  const [appliedFilterStartDate, setAppliedFilterStartDate] = useState(localStorage.getItem("appliedFilterStartDate-1") || "");
  const [appliedFilterEndDate, setAppliedFilterEndDate] = useState(localStorage.getItem("appliedFilterEndDate-1") || "");
  // const [showDateRange, setShowDateRange] = useState(false);
  const [showDateRange, setShowDateRange] = useState(
    localStorage.getItem("showDateRange-1") === "true"
  );
  const [employees, setEmployees] = useState([]);
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  // Save state to localStorage when values change
  useEffect(() => {
    localStorage.setItem("showDateRange-1", showDateRange);
  }, [showDateRange]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setMessage("Copied to clipboard!");
      setTimeout(() => setMessage(""), 1000);  // Optional: Show a message
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  const downloadExcel = () => {
    if (!filteredData || filteredData.length === 0) {
      alert("No data available to export.");
      return;
    }

    // Define the fields to export
    const fields = [
      { key: "leadid", label: "LEAD ID", width: 15 },
      { key: "name", label: "NAME", width: 20 },
      { key: "email", label: "EMAIL", width: 25 },
      { key: "country_code", label: "COUNTRY CODE", width: 10 },
      { key: "phone_number", label: "PHONE NUMBER", width: 15 },
      { key: "sources", label: "SOURCES", width: 20 },
      { key: "another_name", label: "ANOTHER NAME", width: 20 },
      { key: "another_email", label: "ANOTHER EMAIL", width: 25 },
      { key: "another_phone_number", label: "ANOTHER PHONE NUMBER", width: 15 },
      { key: "description", label: "DESCRIPTION", width: 30 },
      { key: "secondarysource", label: "SECONDARY SOURCE", width: 20 },
      { key: "origincity", label: "ORIGIN CITY", width: 15 },
      { key: "destination", label: "DESTINATION", width: 15 },
      { key: "created_at", label: "CREATED AT", width: 20 },
      { key: "primaryStatus", label: "PRIMARY STATUS", width: 15 },
      { key: "secondaryStatus", label: "SECONDARY STATUS", width: 15 },
      { key: "primarySource", label: "PRIMARY SOURCE", width: 20 },
      { key: "channel", label: "CHANNEL", width: 15 }
    ];

    // Transform the data to only include specified fields
    const exportData = filteredData.map(row => {
      let newRow = {};
      fields.forEach(field => {
        newRow[field.label] = row[field.key] || ""; // Use field label as header
      });
      return newRow;
    }); 

    // Create a new workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Apply column widths
    ws["!cols"] = fields.map(field => ({ width: field.width }));

    // Append sheet and save file
    XLSX.utils.book_append_sheet(wb, ws, "Filtered Leads");
    const fileName = `Filtered_Leads_${new Date().toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  useEffect(() => {
    // const fetchEnquiries = async () => {
    //   try {
    //     const response = await fetch(`${webhookUrl}/api/enquiries`);
    //     const data = await response.json();
    //     const filteredData = data.filter((enquiry) => enquiry.managerAssign !== userId && enquiry.managerid == userId && enquiry.status == "lead");
    //     setData(filteredData);
    //   } catch (error) {
    //     console.error("Error fetching enquiries:", error);
    //   }
    // };

    // const fetchEnquiries = async () => {
    //    setLoading(true); // Start loading
    //   try {
    //     const response = await fetch(`${baseURL}/api/addleads/statuslead`);
    //     const json = await response.json();

    //     // Ensure array exists
    //     const list = Array.isArray(json.data) ? json.data : [];

    //     // Filter: not assigned to admin
    //     const filtered = list.filter(
    //       (enquiry) =>
    //         enquiry.managerAssign !== userId && // managerAssign not current user
    //         enquiry.managerid == userId        // managerid is current user
    //     );

    //     setData(filtered);

    //   } catch (error) {
    //     console.error('Error fetching enquiries:', error);
    //   } finally {
    //   setLoading(false); // Stop loading
    // }

    // };



    const fetchEmployees = async () => {
      try {
        const response = await axios.get(`${baseURL}/employeesassign`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        console.log(response.data);
        setEmployees(response.data);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    // fetchEnquiries();
    fetchEmployees();
  }, [authToken, userId]);

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const pageFromUrl = parseInt(params.get("page"));
      const pageSizeFromUrl = parseInt(params.get("pageSize"));

  if (!isNaN(pageFromUrl)) {
    setPageIndex(pageFromUrl - 1); 
  }
}, [location.search]);

  const handleEdit = (leadId,currentPage) => {
                 const params = new URLSearchParams(location.search);
  const pageSize = params.get('pageSize') || '20';

    navigate(`/m-edit-lead/${leadId}?page=${currentPage + 1}&pageSize=${pageSize}`, {
      state: { leadid: leadId },
    });
  };


  const handleAddUser = (lead,currentPage) => {
                     const params = new URLSearchParams(location.search);
  const pageSize = params.get('pageSize') || '20';


    navigate(`/m-create-customer-opportunity/${lead.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`);
  };
  const handleAddLead = () => {
    navigate('/m-add-leads');
  };


  const handleViewLeads = (lead,currentPage) => {
                     const params = new URLSearchParams(location.search);
  const pageSize = params.get('pageSize') || '20';


    navigate(`/m-view-lead/${lead.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, {
      state: { leadid: lead.leadid, source: "my-team-leads" },
    });
  };




  const handleCommentClick = (lead) => {
  setSelectedLeadForComment(lead);
  setShowCommentModal(true);
};

  // const handleDelete = async (leadid) => {
  //   // const confirmDelete = window.confirm("Are you sure you want to delete this Lead?");
  //   // if (!confirmDelete) return;
  //   try {
  //     const response = await fetch(`${baseURL}/api/deleteByLeadId/${leadid}`, {
  //       method: 'DELETE',
  //     });

  //     if (response.ok) {
  //       setData((prevData) => prevData.filter((item) => item.leadid !== leadid));
  //       setMessage('The lead has been deleted successfully.');
  //       setTimeout(() => setMessage(""), 3000);
  //     } else {
  //       setMessage('Failed to delete the lead. Please try again later.');
  //       setTimeout(() => setMessage(""), 3000);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     setMessage('An unexpected error occurred while deleting the lead.');
  //     setTimeout(() => setMessage(""), 3000);
  //   }
  // };

  const [dropdownOptions, setDropdownOptions] = useState({
  primary: [],
  secondary: {}
});

useEffect(() => {
  fetchLeadStatus();
}, []);

const fetchLeadStatus = async () => {
  try {
    const res = await axios.get(`${baseURL}/api/lead-status`);
    
    setDropdownOptions({
      primary: res.data.primary || [],
      secondary: res.data.secondary || {}
    });

  } catch (error) {
    console.error("Error fetching lead status:", error);
  }
};

  // const dropdownOptions = {
  //   primary: ["New", "No Response", "Duplicate", "False Lead", "Junk", "Plan Cancelled"],
  //   secondary: {
  //     New: ["Yet to Contact", "Not picking up call", "Asked to call later"],
  //     "No Response": [],
  //     Duplicate: [],
  //     "False Lead": [],
  //     Junk: ["Plan Cancelled", "Plan Delayed", "Already Booked", "Others"],
  //     "Plan Cancelled": [],
  //   },
  // };

  // const handlePrimaryStatusChange = (value, rowId) => {
  //   setData((prevData) =>
  //     prevData.map((row) =>
  //       row.leadid === rowId
  //         ? {
  //           ...row,
  //           primaryStatus: value,
  //           secondaryStatus: "",
  //         }
  //         : row
  //     )
  //   );
  //   updateLeadStatus(rowId, value, "");
  // };

  // const handleSecondaryStatusChange = (value, rowId) => {
  //   setData((prevData) =>
  //     prevData.map((row) =>
  //       row.leadid === rowId ? { ...row, secondaryStatus: value } : row
  //     )
  //   );
  //   const lead = data.find((lead) => lead.leadid === rowId);
  //   updateLeadStatus(rowId, lead?.primaryStatus || "", value);
  // };
  const updateLeadStatus = async (leadId, primaryStatus, secondaryStatus) => {
  // ✅ Optimistic — instant UI update
  queryClient.setQueryData(['manager-add-leads', userId], (old = []) =>
    old.map((r) =>
      r.leadid === leadId
        ? { ...r, primaryStatus, secondaryStatus: secondaryStatus || '' }
        : r
    )
  );
 
  try {
    const response = await axios.put(`${baseURL}/api/leads/status/${leadId}`, {
      primaryStatus,
      secondaryStatus: secondaryStatus || '',
    });
    if (response.status === 200) {
      setMessage('Status updated successfully.');
      setTimeout(() => setMessage(''), 3000);
      return true;
    }
  } catch {
    queryClient.invalidateQueries(['manager-add-leads', userId]); // ✅ rollback
    setMessage('Update failed, reverting...');
    setTimeout(() => setMessage(''), 3000);
  }
  return false;
};


  const handleAssignLead = async (leadid, employeeId, status) => {
    const selectedEmp = employees.find((emp) => emp.id === parseInt(employeeId));
    const employeeName = selectedEmp ? selectedEmp.name : "";

    if (!employeeName) {
      setMessage("Please select a valid employee.");
      setTimeout(() => setMessage(""), 3000);
      return;
    }
    console.log(leadid, employeeId, employeeName, userName, status);
    try {
      const response = await axios.post(`${baseURL}/api/assign-lead`, {
        leadid,
        employeeId,

        employeeName,
        status,
        userId,
        userName
      });
      setMessage(response.data.message);
      setTimeout(() => setMessage(""), 3000);

     queryClient.setQueryData(['manager-add-leads', userId], (oldData = []) =>
  oldData.map((lead) =>
    lead.leadid === leadid
      ? { ...lead, assignedSalesName: employeeName }
      : lead
  )
);

    } catch (error) {
      console.error("Error assigning lead:", error);
    }
  };

  const handleSelfAssign = async (leadid) => {
    try {
      const response = await axios.post(`${baseURL}/api/assign-manager`, {
        leadid,
        userId, // Use the userId from context
      });

      if (response.status === 200) {
        setMessage(response.data.message);
        setTimeout(() => setMessage(""), 3000);
        window.location.reload();

        // Update the local state to reflect the assignment
       queryClient.setQueryData(['manager-add-leads', userId], (oldData = []) =>
  oldData.map((lead) =>
    lead.leadid === leadid
      ? { ...lead, managerAssign: userId }
      : lead
  )
);

      } else {
        setMessage('Failed to assign the lead. Please try again.');
        setTimeout(() => setMessage(""), 3000);
      }
    } catch (error) {
      console.error("Error assigning lead:", error);
      setMessage('An error occurred while assigning the lead. Please try again.');
      setTimeout(() => setMessage(""), 3000);
    }
  };



  useEffect(() => {
    localStorage.setItem("searchTerm-1", searchTerm);
    localStorage.setItem("filterStatus-1", filterStatus);
    localStorage.setItem("filterDestination-1", filterDestination);
    localStorage.setItem("filterOppStatus1-1", filterOppStatus1);
    localStorage.setItem("filterOppStatus2-1", filterOppStatus2);

    localStorage.setItem("filterAssignee-1", filterAssignee);
    localStorage.setItem("filterStartDate-1", filterStartDate);
    localStorage.setItem("filterEndDate-1", filterEndDate);
    localStorage.setItem("appliedFilterStartDate-1", appliedFilterStartDate);
    localStorage.setItem("appliedFilterEndDate-1", appliedFilterEndDate);
  }, [
    searchTerm, filterStatus, filterDestination, filterOppStatus1, filterOppStatus2,
    filterAssignee, filterStartDate, filterEndDate,
    appliedFilterStartDate, appliedFilterEndDate
  ]);

  const clearFilters = () => {
    setSearchTerm("");
    setFilterStatus("");
    setFilterDestination("");
    setFilterOppStatus1("Open"); // Reset to "open" when filters are cleared
    setFilterOppStatus2("");

    setFilterAssignee("");
    setFilterStartDate("");
    setFilterEndDate("");
    setAppliedFilterStartDate("");
    setAppliedFilterEndDate("");
     setPageIndex(0);
      const url = new URL(window.location);
                    url.searchParams.delete('page');
                            url.searchParams.set('pageSize', '20'); 
      url.searchParams.delete('pageSize');

                    window.history.pushState({}, '', url);
    localStorage.removeItem("potentialLeadsFilters");
  };


  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const matchesFreeText = !searchTerm || Object.values(item).some(val => val && val.toString().toLowerCase().includes(searchTerm.toLowerCase()));
      const actualPrimaryStatus = item.primaryStatus ? item.primaryStatus.toLowerCase() : "Open";
      const matchesPrimaryStatus =
        !filterOppStatus1 || actualPrimaryStatus === filterOppStatus1.toLowerCase();
      const matchesSecondaryStatus =
        !filterOppStatus2 || (item.secondaryStatus && item.secondaryStatus.toLowerCase() === filterOppStatus2.toLowerCase());
      const matchesDestination = !filterDestination || (item.destination && item.destination.toLowerCase() == filterDestination.toLowerCase());
      const matchesAssignee = !filterAssignee || (item.assignedSalesName && item.assignedSalesName.toLowerCase() == filterAssignee.toLowerCase());
      const matchesDateRange = (() => {
        if (appliedFilterStartDate && appliedFilterEndDate) {
          const start = new Date(appliedFilterStartDate);
          const end = new Date(appliedFilterEndDate).setHours(23, 59, 59, 999);
          const createdAt = new Date(item.created_at);
          return createdAt >= start && createdAt <= end;
        }
        return true;
      })();


      return matchesFreeText && matchesPrimaryStatus && matchesDestination && matchesAssignee && matchesSecondaryStatus && matchesDateRange;
    });
  }, [searchTerm, filterOppStatus1, filterAssignee, filterDestination, filterOppStatus2, appliedFilterStartDate, appliedFilterEndDate, data]);

  const uniqueDestinations = useMemo(() => {
    // Filter out empty destinations and normalize valid ones
    const normalizedDestinations = data
      .map(item => item.destination?.trim()) // Trim spaces and handle potential undefined/null values
      .filter(dest => dest) // Remove empty values
      .map(dest => dest.toLowerCase()); // Convert to lowercase for uniqueness

    // Get unique values and format them
    return [...new Set(normalizedDestinations)]
      .map(dest => dest.charAt(0).toUpperCase() + dest.slice(1)); // Capitalize first letter
  }, [data]);


  const columns = useMemo(
    () => [

      {
        Header: "LeadId",
        accessor: "leadid",

      },
      {
        Header: "Name",
        accessor: "name",
              Cell: ({ row }) => {
          const currentPage = pageIndex; 
              const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
          return (
          <div>
            <div
              style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
              onClick={() => handleViewLeads(row.original, currentPage, pageSize)}
            >
              {row.original.name}
            </div>
          </div>
        )
      }
    },
      {
        Header: "Mobile",
        accessor: "phone_number",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <a
              href={`https://wa.me/${row.original.phone_number}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "blue", cursor: "pointer" }}
              title="Chat on WhatsApp"
            >
              {row.original.phone_number}
            </a>
            <FaCopy
              style={{ marginLeft: "8px", cursor: "pointer", color: "#ff9966" }}
              onClick={() => copyToClipboard(row.original.phone_number)}
              title="Copy Phone Number"
            />
          </div>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: ({ row }) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // Push copy button to the right
              width: "100%",
              maxWidth: "200px", // Adjust width as needed
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100px",
              }}
              title={row.original.email} // Show full email on hover
            >
              {row.original.email}
            </div>
            <FaCopy
              style={{ cursor: "pointer", color: "#ff9966" }}
              onClick={() => copyToClipboard(row.original.email)}
              title="Copy Email"
            />
          </div>
        ),
      },
      {
        Header: "Destination",
        accessor: "destination",
        Cell: ({ row }) => (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100px",
            }}
            title={row.original.destination}
          >
            {row.original.destination}
          </div>
        ),
      },




      {
        Header: "Lead Status",
        Cell: ({ row }) => {
          const { fontSize } = useContext(FontSizeContext);
          const { primaryStatus, secondaryStatus, leadid } = row.original;

          // Local state for unsaved changes
          const [localPrimary, setLocalPrimary] = useState(primaryStatus);
          const [localSecondary, setLocalSecondary] = useState(secondaryStatus);
          const [isDirty, setIsDirty] = useState(false);

          // Reset local state when original props change
          useEffect(() => {
            setLocalPrimary(primaryStatus);
            setLocalSecondary(secondaryStatus);
            setIsDirty(false);
          }, [primaryStatus, secondaryStatus]);

          // Get secondary options for current primary selection
          const secondaryOptions = localPrimary ? (dropdownOptions.secondary[localPrimary] || []) : [];
          const isSecondaryDisabled = !localPrimary || secondaryOptions.length === 0;

          const handlePrimaryChange = (e) => {
            const newPrimary = e.target.value;
            setLocalPrimary(newPrimary);
            setLocalSecondary(""); // Reset secondary when primary changes
            setIsDirty(true);
          };

          const handleSecondaryChange = (e) => {
            setLocalSecondary(e.target.value);
            setIsDirty(true);
          };

          const canSave =
            localPrimary &&
            (secondaryOptions.length === 0 || (secondaryOptions.length > 0 && localSecondary));

         const handleSave = async () => {
  try {
    await updateLeadStatus(leadid, localPrimary, localSecondary);

    queryClient.setQueryData(['manager-add-leads', userId], (oldData = []) =>
      oldData.map((row) =>
        row.leadid === leadid
          ? {
              ...row,
              primaryStatus: localPrimary,
              secondaryStatus: localSecondary,
            }
          : row
      )
    );

    setIsDirty(false);

  } catch (error) {
    console.error('Error saving status:', error);
  }
};


          return (

            <div className="d-flex align-items-center" style={{ fontSize: fontSize }}>

              {/* Primary Status Dropdown */}
              <select
                value={localPrimary || ""}
                onChange={handlePrimaryChange}
                className="form-select me-2"

                style={{ fontSize: fontSize }}

              >
                <option value="">Select Primary</option>
                {dropdownOptions.primary.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              {/* Secondary Status Dropdown */}
              <select
                value={localSecondary || ""}
                onChange={handleSecondaryChange}
                className="form-select me-2"

                style={{ fontSize: fontSize }}

                disabled={isSecondaryDisabled}
              >
                <option value="">{isSecondaryDisabled ? "Select Secondary" : "Select Secondary"}</option>
                {secondaryOptions.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              {/* Save Button (only shown when there are unsaved changes) */}
              {isDirty && (
                <FaSave
                  onClick={canSave ? handleSave : undefined}
                  title={canSave ? "Save changes" : "Select secondary status to enable"}
                  style={{
                    color: canSave ? "#ff9966" : "#ccc",
                    cursor: canSave ? "pointer" : "not-allowed",

                    fontSize: "32px",

                  }}
                />
              )}
            </div>
          );
        },
      },


      {
        Header: "Source",
        accessor: "sources",
      },

      {
        Header: () => <div style={{ whiteSpace: "nowrap" }}>Customer Status</div>,
        accessor: "customer_status",
      }
      ,
      {
        Header: "Assign",
        accessor: "id",
        Cell: ({ cell: { row } }) => {
          const { fontSize } = useContext(FontSizeContext);
          const assignedSalesId = row.original.assignedSalesId || "";
          const [selectedEmployee, setSelectedEmployee] = useState(assignedSalesId);
          const [showIcon, setShowIcon] = useState(false);

          const handleChange = (e) => {
            const newValue = e.target.value;
            setSelectedEmployee(newValue);
            setShowIcon(newValue !== assignedSalesId);
          };

          const handleAssignClick = async () => {
            if (selectedEmployee) {
              if (selectedEmployee === "self") {
                // Call the new API for self assignment
                await handleSelfAssign(row.original.leadid);
              } else {
                handleAssignLead(row.original.leadid, selectedEmployee, row.original.status);
              }
              setShowIcon(false); // Hide icon after assignment
            } else {
              setMessage("Please select an employee to assign the lead.");
              setTimeout(() => setMessage(""), 3000);
            }
          };

          return (
            <div className="d-flex align-items-center" style={{ fontSize: fontSize }}>
              <Form.Select
                value={selectedEmployee}
                onChange={handleChange}
                className="me-2" style={{ fontSize: fontSize }}
              >
                <option value="">Select Employee</option>
                <option value="self">Self</option> {/* Add Self option */}
                {employees.map((employee) => (
                  <option key={employee.id} value={employee.id}>
                    {employee.name}
                  </option>
                ))}
              </Form.Select>
              {showIcon && (
                <HiUserGroup
                  style={{ color: "#ff9966", cursor: "pointer", fontSize: "20px" }}
                  onClick={handleAssignClick}
                />
              )}
            </div>
          );
        },
      },



      {
        Header: "Actions",
        Cell: ({ row }) => {
              const currentPage = pageIndex; // Capture current page index
                                const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';

return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <FaEdit
              style={{ color: "#ff9966", cursor: "pointer" }}
              onClick={() => handleEdit(row.original.leadid,currentPage,pageSize)}
            />
            <FaEye
              style={{ color: "#ff9966", cursor: "pointer" }}
              onClick={() => handleViewLeads(row.original,currentPage,pageSize)}
            />
            {/* <FaTrash
              style={{ color: "#ff9966", cursor: "pointer" }}
              onClick={() => handleDelete(row.original.leadid)}
            /> */}
            <FaUserPlus
              style={{ color: "ff9966", cursor: "pointer" }}
              onClick={() => handleAddUser(row.original,currentPage,pageSize)}
            />
            {/* <FaComment
              style={{ color: "#ff9966", cursor: "pointer" }}
              onClick={() => navigate(`/m-comments/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, { state: { leadid: row.original.leadid } })}
            /> */}

                              <FaComment
                            style={{ color: "#ff9966", cursor: "pointer" }}
                            onClick={() => handleCommentClick(row.original,)}
                          />
          </div>
)
       }
      }

    ],
    [employees,pageIndex,location]
  );

  return (
    <div className="salesViewLeadsContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesViewLeads ${collapsed ? "collapsed" : ""}`}>
        <div className="ViewLead-container mb-5">
          <div className="ViewLead-table-container">
            <Row className="mb-3">
              <Col className="d-flex justify-content-between align-items-center">
                <h3>Lead Details</h3>
                {message && <div className="alert alert-info">{message}</div>}
                <Button onClick={handleAddLead}>Add Leads</Button>
              </Col>
            </Row>
            <Row className="mb-3 align-items-center">
              <Col md={6} className="d-flex align-items-center gap-2">
                <input type="text" className="form-control" placeholder="Free Text Search..." value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    localStorage.setItem("searchTerm-1", e.target.value);
                     setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }} />
                {showDateRange ? (
                  <FaTimes
                    onClick={() => {
                      setShowDateRange(false);
                      localStorage.setItem("showDateRange-1", "false");
                      setFilterStartDate("");
                      setFilterEndDate("");
                      setAppliedFilterStartDate("");
                      setAppliedFilterEndDate("");
                      localStorage.removeItem("filterStartDate-1");
                      localStorage.removeItem("filterEndDate-1");
                      localStorage.removeItem("appliedFilterStartDate-1");
                      localStorage.removeItem("appliedFilterEndDate-1");
                    }} style={{ cursor: "pointer", fontSize: "1.5rem" }} title="Hide Date Range" />
                ) : (
                  <FaCalendarAlt
                    onClick={() => {
                      setShowDateRange(true);
                      localStorage.setItem("showDateRange-1", "true");
                    }} style={{ cursor: "pointer", fontSize: "1.5rem" }} title="Show Date Range" />
                )}
                {showDateRange && (
                  <div className="d-flex align-items-center gap-2">
                    <input type="date" className="form-control" value={filterStartDate} onChange={(e) => setFilterStartDate(e.target.value)} />
                    <span>to</span>
                    <input type="date" className="form-control" value={filterEndDate} onChange={(e) => setFilterEndDate(e.target.value)} />
                    <button className="btn btn-primary" onClick={() => { { setAppliedFilterStartDate(filterStartDate); setAppliedFilterEndDate(filterEndDate); }
                   setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);} }>OK</button>
                  </div>
                )}
              </Col>
              <Col md={6} className="d-flex justify-content-end">
                <button className="btn btn-secondary" onClick={clearFilters}>Clear Filters</button></Col>
            </Row>
            <Row className="mb-3">
              <Col md={3}>
                <select className="form-select" value={filterDestination} onChange={(e) =>{ setFilterDestination(e.target.value)
                   setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);}
                }>
                  <option value="">Destinations</option>
                  {uniqueDestinations.map((dest) => (
                    <option key={dest} value={dest}>{dest}</option>
                  ))}
                </select>
              </Col>
              <Col md={2}>
                <select
                  className="form-select"
                  value={filterOppStatus1}
                  onChange={(e) => {
                    setFilterOppStatus1(e.target.value);
                    setFilterOppStatus2("");
                     setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                >
                   <option value="">Primary Status</option>

    {dropdownOptions.primary.map((status) => (
      <option key={status} value={status}>
        {status}
      </option>
    ))}
                </select>
              </Col>
              <Col md={3}>
                <select
                  className="form-select"
                  value={filterOppStatus2}
                  onChange={(e) => {setFilterOppStatus2(e.target.value)
                     setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);}
                  }
                  
                >
                  <option value="">Secondary Status</option>
                  {dropdownOptions.secondary[filterOppStatus1]?.map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </Col>
              <Col md={2}>
                <select className="form-select" value={filterAssignee} onChange={(e) =>{ setFilterAssignee(e.target.value)
                   setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);}
                }>
                  <option value="">Associates</option>
                  {employees.map((employee) => (
                    <option key={employee.id} value={employee.name}>{employee.name}</option>
                  ))}
                </select>
              </Col>
              {/* <Col md={2}>
                <button className="btn btn-success" onClick={downloadExcel}>
                  <FaDownload /> Download Excel</button>
              </Col> */}
            </Row>
            
             {loading ? (
                         <Loader />
                       ) : data.length === 0 ? (
                                   <div className="text-center p-5">
                                     <p>No data available</p>
                                   </div>
                                 ) : (
 <DataTable 
                columns={columns} 
                data={filteredData} 
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
              />
          )}

          
          </div>
        </div>
      </div>
<CommentsModalPopmangaer
  show={showCommentModal}
  onHide={() => {
    setShowCommentModal(false);
    setSelectedLeadForComment(null);
  }}
  selectedLead={selectedLeadForComment}
  baseURL={baseURL}
  userName={userName}
/>
    </div>
  );
};

export default ViewLeads;